
/* eslint-disable */
const globModules = [
  {
    name: 'header',
    loader: () => import('./modules/header'),

  },
  {
    name: 'footer',
    loader: () => import('./modules/footer'),

  },
  {
    name: 'form',
    loader: () => import('./modules/form'),

  },
  {
    name: 'contact-us',
    loader: () => import('./modules/contact-us'),

  },
  {
    name: 'video-row',
    loader: () => import('./modules/video-row'),

  },
  {
    name: 'gallery',
    loader: () => import('./modules/gallery'),

  },
  {
    name: 'content-card',
    loader: () => import('./modules/content-card'),

  },
  {
    name: 'alert',
    loader: () => import('./modules/alert'),

  },
  {
    name: 'media-masthead',
    loader: () => import('./modules/media-masthead'),

  }
];

export default globModules;
